var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LANGUAGES } from "../../../constants";
import Lang from "lang.js";
import jsonTranslations from "../../../lang.json";
export var default_settings = {
    bot_id: null,
    name: null,
    display_chatbot_name: true,
    header_text_color: null,
    logo: null,
    trigger_icon: null,
    new_user_prompt_message: null,
    new_user_prompt_delay: 0,
    new_user_prompt_background_color: null,
    new_user_prompt_text_color: null,
    new_user_prompt_hide_on_mobile: false,
    app_domain: null,
    language: LANGUAGES.EN,
    enable_surveys: false,
    survey_primary_question: {},
};
export var KEYBOARD_NAVIGATION_ORDER_TOP = 'top';
export var KEYBOARD_NAVIGATION_ORDER_BOTTOM = 'bottom';
var getChatBotIdFromElement = function () {
    var elScript = document.getElementById("alwayson_chatbot_script");
    if (!elScript)
        throw new Error('Chatbot script element id "#alwayson_chatbot_script" not found!');
    var srcString = elScript.getAttribute('src') || '';
    var urlSearchParams = new URLSearchParams(srcString.split("?")[1] || '');
    return urlSearchParams.get('id') || null;
};
export var getSettings = function () {
    // @ts-ignore
    var update_settings = window.alwayson_settings || {
        bot_id: getChatBotIdFromElement()
    };
    return __assign(__assign({}, default_settings), update_settings);
};
export var getTranslation = function (key, language) {
    if (language === void 0) { language = null; }
    var lang = new Lang({
        messages: jsonTranslations,
        locale: language || getSettings().language,
        fallback: LANGUAGES.EN
    });
    return lang.get(key);
};
